import React from 'react';
import { Text } from '@front/gatsby-ui';
import { clamp, defaultTo } from 'ramda';

import Star from 'Img/star.inline.svg';

const Rating = ({ rating, ...rest }) => (
  <Text
    display="flex"
    alignItems="center"
    color="basic.4"
    fontWeight="bold"
    {...rest}
  >
    <Star />
    &nbsp;
    {`${clamp(0, 10, defaultTo(0, Number(rating)))}`}
    <Text
      fontWeight="body"
      as="span"
    >
      /10
    </Text>
  </Text>
);

export default Rating;
